import './Dashboard.css';

import {
  AllowedAccessMapContext,
  UserContext,
  filterLcmApps
} from 'vrlcm-gui-utils';
import {
  ContentArea,
  ContentContainer,
  MainContainer
} from '@vmware-react/clarity';
import { DashboardAction, requestApps } from '../../actions/Dashboard';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AppCards from './AppCards';
import { CenterAlignedSpinner } from 'vrlcm-gui-components';
import { Dashboard as DashboardState } from '../../types/Dashboard';
import { Dispatch } from 'redux';
import RecentVisitedPages from './RecentVisitedPages/RecentVisitedPages';
import { StoreState } from '../../types';
import { l10n } from 'i18n/i18nUtil';

const Dashboard: React.FunctionComponent = () => {
  const { apps, fetching } = useSelector<StoreState, DashboardState>(
    s => s.dashboard
  );
  const user = useContext(UserContext);

  const dispatch = useDispatch<Dispatch<DashboardAction>>();
  useEffect(() => {
    dispatch(requestApps());
  }, [dispatch]);
  const allowedAccessMap = useContext(AllowedAccessMapContext);

  return (
    <MainContainer className="shell">
      <ContentContainer>
        <ContentArea>
          <div className="dashboard-lcm">
            {fetching ? (
              <div style={{ marginTop: '45px' }}>
                <CenterAlignedSpinner size="md" text={l10n('fetchingServices')} />
              </div>
            ) : (
              user && (
                <>
                  <AppCards
                    apps={filterLcmApps(user, apps, allowedAccessMap)}
                  />
                  <RecentVisitedPages
                    apps={filterLcmApps(user, apps, allowedAccessMap)}
                  />
                </>
              )
            )}
          </div>
        </ContentArea>
      </ContentContainer>
    </MainContainer>
  );
};

export default Dashboard;
